import { APP_NAMES } from '~/core/constants'
import appConfig from './app-config'

import VpaasApp from './components/vpaas/app'
import MeetApp from './components/meet/app'
import SuccessPageVpaas from './components/vpaas/success-page'
import SuccessPageMeet from './components/meet/success-page'
import CancelPageVpaas from './components/vpaas/cancel-page'
import CancelPageMeet from './components/meet/cancel-page'
import JaaSTitle from './components/vpaas/subscription-expired/title'
import MeetTitle from './components/meet/subscription-expired/title'

const COMPONENT_MAPPINGS = {
  [APP_NAMES.VPAAS]: {
    App: VpaasApp,
    SuccessPage: SuccessPageVpaas,
    CancelPage: CancelPageVpaas,
    Header: JaaSTitle
  },
  [APP_NAMES.MEET]: {
    App: MeetApp,
    SuccessPage: SuccessPageMeet,
    CancelPage: CancelPageMeet,
    Header: MeetTitle
  }
}

export default {
  get current () {
    return COMPONENT_MAPPINGS[appConfig.current.name]
  }
}
